import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-211a11fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-2 d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "photo text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-sm-10" }
const _hoisted_6 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label text-muted" }, "คำสั่งแต่งตั้ง:", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: "",
  hidden: ""
}, "กรุณาเลือก ร.นรม./รมต.นร. ผู้อนุมัติโครงการ", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "position",
  class: "form-label text-muted"
}, " ตำแหน่ง: ", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "photo-image",
          src: _ctx.photoPreview,
          width: "60",
          height: "70",
          alt: "preview"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.cabinets.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cabinetId) = $event)),
              class: "form-select",
              "aria-label": "cabinet",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cabinetChange && _ctx.cabinetChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinets, (cabinet) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cabinet.id,
                  value: cabinet.id
                }, _toDisplayString(_ctx.cabinetLabel(cabinet)), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.cabinetId]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", {
          for: "cabinetMinisterId",
          class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.cabinetMinisterId}])
        }, " ร.นรม./รมต.นร. ผู้อนุมัติโครงการ: ", 2),
        (_ctx.submited && _ctx.errors.cabinetMinisterId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " * กรุณาเลือก ร.นรม./รมต.นร. ผู้อนุมัติโครงการ "))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.approvementForm.cabinetMinisterId) = $event)),
          class: _normalizeClass(["form-select", {'is-invalid': _ctx.submited && _ctx.errors.cabinetMinisterId}]),
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args))),
          "aria-label": "cabinetMinister"
        }, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cabinetMinisters, (cabinetMinister, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: cabinetMinister.id
            }, _toDisplayString(cabinetMinister.minister.fullName), 9, _hoisted_12))
          }), 128))
        ], 34), [
          [
            _vModelSelect,
            _ctx.approvementForm.cabinetMinisterId,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("input", {
          type: "text",
          value: _ctx.selectedMinister ? _ctx.selectedMinister.position.name : 'กรุณาเลือก ร.นรม./รมต.นร. ผู้อนุมัติโครงการ',
          class: "form-control",
          "aria-label": "position",
          readonly: ""
        }, null, 8, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("label", {
          for: "approvedDate",
          class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.approvedDate}])
        }, " วันที่อนุมัติโครงการ: ", 2),
        (_ctx.submited && _ctx.errors.approvedDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " * กรุณาป้อนวันที่อนุมัติ "))
          : _createCommentVNode("", true),
        _createVNode(_component_Datepicker, {
          modelValue: _ctx.approvementForm.approvedDate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.approvementForm.approvedDate) = $event)),
          enableTimePicker: false,
          locale: "th-TH",
          format: "dd/MM/yyyy",
          weekStart: "0",
          position: "left",
          autoApply: "",
          placeholder: "กรุณาป้อนวันที่อนุมัติ...",
          class: _normalizeClass(["form-control p-0", {'is-invalid': _ctx.submited && _ctx.errors.approvedDate}]),
          onChange: _ctx.unsubmit
        }, null, 8, ["modelValue", "class", "onChange"])
      ])
    ])
  ]))
}